export const REQUESTED = "REQUESTED";
export const SUCCEEDED = "SUCCEEDED";
export const FAILED = "FAILED";

export const fluxTypes = [REQUESTED, SUCCEEDED, FAILED];

export default {
  REQUESTED,
  SUCCEEDED,
  FAILED,
  fluxTypes,
};
